(function () {
  document.documentElement.classList.add('rvm-home-active');

  function normalize(value) {
    return (value || '')
      .toString()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .toLowerCase()
      .trim();
  }

  function setup(root) {
    if (!root || root.dataset.rvmReady === 'true') return;
    root.dataset.rvmReady = 'true';

    var listing = root.querySelector('[data-rvm-listing]');
    var cards = Array.prototype.slice.call(root.querySelectorAll('[data-rvm-event]'));
    var searchInputs = Array.prototype.slice.call(root.querySelectorAll('[data-rvm-search]'));
    var filterButtons = Array.prototype.slice.call(root.querySelectorAll('[data-rvm-filter]'));
    var count = root.querySelector('[data-rvm-count]');
    var grid = root.querySelector('[data-rvm-grid]');
    var empty = root.querySelector('[data-rvm-empty]');
    var reset = root.querySelector('[data-rvm-reset]');
    var searchForm = root.querySelector('[data-rvm-search-form]');
    var headerSearch = root.querySelector('[data-rvm-header-search]');
    var headerSearchInput = root.querySelector('[data-rvm-header-search-input]');
    var heroCarousel = root.querySelector('[data-rvm-hero-carousel]');
    var heroSlides = Array.prototype.slice.call(root.querySelectorAll('[data-rvm-hero-slide]'));
    var heroDots = Array.prototype.slice.call(root.querySelectorAll('[data-rvm-hero-dot]'));
    var heroCurrent = root.querySelector('[data-rvm-hero-current]');
    var heroPrev = root.querySelector('[data-rvm-hero-prev]');
    var heroNext = root.querySelector('[data-rvm-hero-next]');
    var radarDisclosure = root.querySelector('[data-rvm-radar-disclosure]');
    var heroTimer = null;
    var heroIndex = 0;
    var activeFilter = 'all';
    var query = '';

    if (radarDisclosure) {
      var radarMobileMedia = window.matchMedia('(max-width: 680px)');
      var syncRadarDisclosure = function (event) {
        var isMobile = event && typeof event.matches === 'boolean'
          ? event.matches
          : radarMobileMedia.matches;

        if (isMobile) radarDisclosure.removeAttribute('open');
        else radarDisclosure.setAttribute('open', '');
      };

      syncRadarDisclosure();
      if (radarMobileMedia.addEventListener) {
        radarMobileMedia.addEventListener('change', syncRadarDisclosure);
      } else if (radarMobileMedia.addListener) {
        radarMobileMedia.addListener(syncRadarDisclosure);
      }
    }

    function showHeroSlide(index) {
      if (!heroSlides.length) return;
      heroIndex = (index + heroSlides.length) % heroSlides.length;

      heroSlides.forEach(function (slide, slideIndex) {
        var isActive = slideIndex === heroIndex;
        slide.classList.toggle('is-active', isActive);
        slide.setAttribute('aria-hidden', isActive ? 'false' : 'true');
        if (isActive) {
          slide.removeAttribute('tabindex');
        } else {
          slide.setAttribute('tabindex', '-1');
        }
      });

      heroDots.forEach(function (dot, dotIndex) {
        var isActive = dotIndex === heroIndex;
        dot.classList.toggle('is-active', isActive);
        dot.setAttribute('aria-current', isActive ? 'true' : 'false');
      });

      if (heroCurrent) heroCurrent.textContent = ('0' + (heroIndex + 1)).slice(-2);
    }

    function stopHeroCarousel() {
      if (heroTimer) window.clearInterval(heroTimer);
      heroTimer = null;
    }

    function startHeroCarousel() {
      stopHeroCarousel();
      if (!root.isConnected) return;
      if (!heroCarousel || heroSlides.length < 2) return;
      if (!window.matchMedia('(min-width: 1081px)').matches) return;
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      if (document.hidden) return;
      if (heroCarousel.matches && heroCarousel.matches(':hover')) return;
      if (heroCarousel.contains(document.activeElement)) return;

      var interval = parseInt(heroCarousel.dataset.rvmCarouselInterval, 10) || 5000;
      heroTimer = window.setInterval(function () {
        if (!root.isConnected) {
          stopHeroCarousel();
          return;
        }
        showHeroSlide(heroIndex + 1);
      }, Math.max(interval, 3000));
    }

    if (heroCarousel && heroSlides.length) {
      heroDots.forEach(function (dot) {
        dot.addEventListener('click', function () {
          showHeroSlide(parseInt(dot.dataset.rvmHeroDot, 10) || 0);
          startHeroCarousel();
        });
      });

      if (heroPrev) {
        heroPrev.addEventListener('click', function () {
          showHeroSlide(heroIndex - 1);
          startHeroCarousel();
        });
      }

      if (heroNext) {
        heroNext.addEventListener('click', function () {
          showHeroSlide(heroIndex + 1);
          startHeroCarousel();
        });
      }

      heroCarousel.addEventListener('mouseenter', stopHeroCarousel);
      heroCarousel.addEventListener('mouseleave', startHeroCarousel);
      heroCarousel.addEventListener('focusin', stopHeroCarousel);
      heroCarousel.addEventListener('focusout', function () {
        window.setTimeout(function () {
          if (!heroCarousel.contains(document.activeElement)) startHeroCarousel();
        }, 0);
      });

      var desktopMedia = window.matchMedia('(min-width: 1081px)');
      if (desktopMedia.addEventListener) {
        desktopMedia.addEventListener('change', startHeroCarousel);
      } else if (desktopMedia.addListener) {
        desktopMedia.addListener(startHeroCarousel);
      }

      document.addEventListener('visibilitychange', function () {
        if (document.hidden) stopHeroCarousel();
        else startHeroCarousel();
      });

      root.rvmStopHeroCarousel = stopHeroCarousel;
      showHeroSlide(0);
      startHeroCarousel();
    }

    if (headerSearch && headerSearchInput) {
      headerSearch.addEventListener('toggle', function () {
        if (headerSearch.open && window.matchMedia('(max-width: 900px)').matches) {
          window.requestAnimationFrame(function () {
            headerSearchInput.focus();
          });
        }
      });

      headerSearch.addEventListener('keydown', function (event) {
        if (event.key === 'Escape' && headerSearch.open) {
          headerSearch.removeAttribute('open');
          var toggle = headerSearch.querySelector('summary');
          if (toggle) toggle.focus();
        }
      });
    }

    function updateButtons() {
      filterButtons.forEach(function (button) {
        var isActive = normalize(button.dataset.rvmFilter) === activeFilter;
        button.classList.toggle('is-active', isActive);
        if (button.hasAttribute('aria-pressed')) {
          button.setAttribute('aria-pressed', isActive ? 'true' : 'false');
        }
      });
    }

    function applyFilters() {
      var visibleCards = [];

      cards.forEach(function (card) {
        var category = normalize(card.dataset.rvmCategory);
        var haystack = normalize(card.dataset.rvmSearch);
        var categoryMatches = activeFilter === 'all' || category === activeFilter;
        var queryMatches = !query || haystack.indexOf(query) !== -1;
        var show = categoryMatches && queryMatches;

        card.hidden = !show;
        card.classList.remove('is-grid-odd', 'is-grid-even', 'is-only-visible');
        if (show) visibleCards.push(card);
      });

      visibleCards.forEach(function (card, index) {
        card.classList.add(index % 2 === 0 ? 'is-grid-odd' : 'is-grid-even');
        card.classList.toggle('is-only-visible', visibleCards.length === 1);
      });

      var visible = visibleCards.length;
      if (count) count.textContent = visible;
      if (grid) grid.hidden = visible === 0;
      if (empty) empty.hidden = visible !== 0;
      updateButtons();
    }

    function setQuery(value, source) {
      query = normalize(value);
      if (query) activeFilter = 'all';
      searchInputs.forEach(function (input) {
        if (input !== source) input.value = value;
      });
      applyFilters();
    }

    searchInputs.forEach(function (input) {
      input.addEventListener('input', function () {
        setQuery(input.value, input);
      });
    });

    filterButtons.forEach(function (button) {
      button.addEventListener('click', function () {
        activeFilter = normalize(button.dataset.rvmFilter) || 'all';
        query = '';
        searchInputs.forEach(function (input) {
          input.value = '';
        });
        applyFilters();

        if (listing && button.closest('.rvm-quick-links')) {
          listing.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      });
    });

    if (searchForm) {
      searchForm.addEventListener('submit', function (event) {
        event.preventDefault();
        setQuery(searchInputs[0] ? searchInputs[0].value : '', searchInputs[0]);
        if (listing) listing.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    }

    if (reset) {
      reset.addEventListener('click', function () {
        activeFilter = 'all';
        query = '';
        searchInputs.forEach(function (input) {
          input.value = '';
        });
        applyFilters();
      });
    }

    applyFilters();
  }

  function setupAll(scope) {
    var context = scope || document;
    if (context.matches && context.matches('[data-rvm-home]')) setup(context);
    Array.prototype.forEach.call(context.querySelectorAll('[data-rvm-home]'), setup);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      setupAll(document);
    });
  } else {
    setupAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    setupAll(event.target);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    var home = event.target.matches && event.target.matches('[data-rvm-home]')
      ? event.target
      : event.target.querySelector && event.target.querySelector('[data-rvm-home]');
    if (home && home.rvmStopHeroCarousel) home.rvmStopHeroCarousel();
    if (!document.querySelector('[data-rvm-home]')) {
      document.documentElement.classList.remove('rvm-home-active');
    }
  });
})();
